
import './style.scss'

const Footer = () => (
  <footer>
    Copyright © 2018 - { new Date().getFullYear() } Yang Lin
  </footer>
)

export default Footer